import classNames from "classnames";

import AlarmIcon from "../../assets/images/alarm-icon2.svg";
import LockIcon from "../../assets/images/lock-icon2.svg";
import ShieldIcon from "../../assets/images/shield-icon2.svg";
import useTranslation from "../../hooks/useTranslation";

import style from "./ChargebeeTrialTimeline.module.css";

interface ChargebeeTrialTimelineProps {
  trialDays: number;
}

const ChargebeeTrialTimeline = ({ trialDays }: ChargebeeTrialTimelineProps) => {
  const { t, m } = useTranslation();

  const reminderDayTitle =
    trialDays - 2 < 3
      ? t(m.Checkout.TrialTimeline.Tomorrow)
      : t(m.Checkout.TrialTimeline.DayN, { day: trialDays - 2 });

  return (
    <div className={classNames(style.timelineWrapper)}>
      <div className={style.horizontalLines}>
        <div></div>
        <div className={style.lineItem}></div>
        <div className={style.lineItem}></div>
        <div></div>
      </div>
      <div className={style.timelineItem}>
        <img src={LockIcon} />
        <div className={style.title}>{t(m.Checkout.TrialTimeline.Today)}</div>
        <div className={style.text}>{t(m.Checkout.TrialTimeline.TodayText)}</div>
      </div>

      <div className={style.timelineItem}>
        <img src={AlarmIcon} />
        <div className={style.title}>{reminderDayTitle}</div>
        <div className={style.text}>{t(m.Checkout.TrialTimeline.ReminderText)}</div>
      </div>

      <div className={style.timelineItem}>
        <img src={ShieldIcon} />
        <div className={style.title}>{t(m.Checkout.TrialTimeline.DayN, { day: trialDays })}</div>
        <div className={style.text}>{t(m.Checkout.TrialTimeline.ChargedText)}</div>
      </div>
    </div>
  );
};

export default ChargebeeTrialTimeline;
